<template>
  <div class="upload-page-wrapper position-relative">
    <!-- Football Player Graphic for Upload Page -->
    <div class="upload-player-bg-container d-none d-lg-block">
      <img
        src="https://snippcheck.blob.core.windows.net/files/Danone_US_2008822_Big10GWP/player-inner.png"
        alt="Football Player"
        class="upload-player-edge-img"
      />
    </div>

    <div class="container position-relative z-index-2 text-center">
      <h1 class="text-uppercase mb-3 d-none">{{ $t('Upload.UplaodTitle') }}</h1>
      <p class="d-none">{{ $t('Upload.UplaodDesc') }}</p>
      <div class="mb-5">
        <section class="wrapper">
          <component
            :is="WidgetComponent"
            :campaign-id="$t('CampaignID')"
          ></component>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {},
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>

<style scoped>
.upload-page-wrapper {
  width: 100%;
  position: relative;
  min-height: 450px;
}

.upload-player-bg-container {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.upload-player-edge-img {
  max-height: 350px;
  width: auto;
  object-fit: contain;
  opacity: 0.95;
}

.z-index-2 {
  position: relative;
  z-index: 2;
}
</style>
